type ScrollFadeMaskOptions = {
  /** Masked distance from the start edge to fully opaque content: hidden control area + fadeSize. */
  start: string
  /** Masked distance from the end edge to fully opaque content: hidden control area + fadeSize. */
  end: string
  /** Width of the transparent-to-opaque transition; does not add layout spacing. */
  fadeSize: string
  direction?: 'to right' | 'to left' | 'to bottom' | 'to top' | `var(--${string})`
}

/**
 * CSS lengths and variables are supported; use 0px for an edge with no hidden content.
 * start/end are distances rather than booleans because they can include a fully hidden control area:
 * - Chat tables use 0px or fadeSize (24px), with no control area.
 * - Tabs use 0px or 52px: 36px hidden beneath the arrow control, then a 16px fade.
 * These values only affect the mask; they do not add layout spacing.
 */
export const scrollFadeMask = ({ start, end, fadeSize, direction = 'to right' }: ScrollFadeMaskOptions): string => {
  // Masks read alpha: currentColor supplies opacity without introducing a rendered colour.
  // Keep content hidden under any controls, then fade in. max() orders the stops even at 0px.
  return `linear-gradient(${direction}, transparent 0, transparent max(0px, calc(${start} - ${fadeSize})), currentColor ${start}, currentColor calc(100% - ${end}), transparent calc(100% - max(0px, calc(${end} - ${fadeSize}))), transparent 100%)`
}
